import { render, staticRenderFns } from "./DeanAdmissionDocumentsStudentView.vue?vue&type=template&id=5055562c"
import script from "./DeanAdmissionDocumentsStudentView.vue?vue&type=script&lang=js"
export * from "./DeanAdmissionDocumentsStudentView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports